import React from 'react';
import CellValue from '@app/shared/components/cell-value/CellValue';
import { Alignment } from '@app/shared/enums/alignment.enum';
import { DividendSetDto } from '@app/shared/models/contracts/project-dto';
import { numericBaseFieldFormattingProps } from '@app/shared/components/form-controls/form-field/form-field-patterns';
import GridTextField from '@app/shared/components/grid-controls/grid-text-field/GridTextField';
import { positiveOrNullValidator } from '@app/core/validations/hook-forms/validators';
import styles from './dividends-table.module.scss';
import classNames from 'classnames';
import { GridFieldTooltipVariation } from '@app/shared/components/grid-controls/grid-field-options';

interface ForecastCellsProps {
  instrumentId: string;
  forecastSet: DividendSetDto | undefined;
  isEligible: boolean;
  forecastDates: string[] | undefined;
  instrumentCreationDates: { instrumentId: string; creationDate: string }[];
}

const ForecastCells: React.FC<ForecastCellsProps> = ({
  instrumentId,
  forecastSet,
  isEligible,
  forecastDates,
  instrumentCreationDates,
}) => {
  if (!forecastSet) {
    return null;
  }
  const instrumentForecast = forecastSet.instruments[instrumentId];
  const instrumentCreationDate = new Date(
    instrumentCreationDates.find((i) => i.instrumentId === instrumentId)?.creationDate ?? ''
  );
  return (
    <>
      {forecastDates &&
        forecastDates.map((date, idx) =>
          instrumentForecast && new Date(date) >= instrumentCreationDate ? (
            <td
              className={classNames({ [styles['ineligible-value']]: !isEligible })}
              key={`${instrumentId}-forecast-${date}`}>
              {isEligible ? (
                <GridTextField
                  name={`forecastDividendSets[${forecastSet.dividendSetId}].instruments[${instrumentId}].dates[${date}].totalDividendValue`}
                  alignment={Alignment.Right}
                  placeholder="0"
                  tooltipVariation={GridFieldTooltipVariation.FixedPosition}
                  {...numericBaseFieldFormattingProps}
                  rules={{ ...positiveOrNullValidator(true) }}
                />
              ) : (
                <CellValue
                  value={instrumentForecast.dates[date]?.totalDividendValue}
                  normalize
                  alignment={Alignment.Right}
                  allowEmptyValues
                />
              )}
            </td>
          ) : (
            <td key={`${instrumentId}-forecast-empty-${idx}`} />
          )
        )}
    </>
  );
};

export default ForecastCells;
